import DataService from "./dataservice.js";

var priceFilter = [];
var colorFilter = [];
var ratingFilter = [];
var prodTimeFilter = [];
var imprintLocationCountFilter = [];
var imprintColorCountFilter = [];
var tagFilter = [];
var sortFilter = '';
var pageNumber = 0;
var pageSize = 0;
var subSearchFilter = '';
var productQuantityFilter = '';
const colorId = 'chkColor_';
const ratingId = 'chkRating_';
const tagId = 'chkTag_';
const prodTimeId = 'chkProductionTime_';
const imprintLocationCountId = 'chkImprintLocationCount_';
const imprintColorCountId = 'chkImprintColorCount_';
const sortId = 'chksort_';
const defaultSort = '-RelevenceScore';
const defaultPageSize = 50;

class FilterValues {
    // Pass in false if the filter does not need to be logged .
    addFilter(filterId, logFilter) {
        if (typeof (logFilter) === 'undefined') logFilter = true;

        if (filterId.indexOf(colorId) === 0) {
            var filterIdValue = filterId.replace(colorId, '');
            colorFilter.push(filterIdValue);

            if (logFilter === true) {
                DataService.filterLog(filterId, filterIdValue);
            }
        } else if (filterId.indexOf(ratingId) === 0) {
            var filterIdValue = filterId.replace(ratingId, '');
            ratingFilter.push(filterIdValue);

            if (logFilter === true) {
                DataService.filterLog(filterId, filterIdValue);
            }
        } else if (filterId.indexOf(prodTimeId) === 0) {
            var filterIdValue = filterId.replace(prodTimeId, '');
            prodTimeFilter.push(filterIdValue);

            if (logFilter === true) {
                DataService.filterLog(filterId, filterIdValue);
            }
        } else if (filterId.indexOf(imprintLocationCountId) === 0) {
            var filterIdValue = filterId.replace(imprintLocationCountId, '');
            imprintLocationCountFilter.push(filterIdValue);

            if (logFilter === true) {
                DataService.filterLog(filterId, filterIdValue);
            }
        } else if (filterId.indexOf(imprintColorCountId) === 0) {
            var filterIdValue = filterId.replace(imprintColorCountId, '');
            imprintColorCountFilter.push(filterIdValue);

            if (logFilter === true) {
                DataService.filterLog(filterId, filterIdValue);
            }
        } else if (filterId.indexOf(tagId) === 0) {
            var filterIdValue = filterId.replace(tagId, '');
            tagFilter.push(filterIdValue);

            if (logFilter === true) {
                DataService.filterLog(filterId, filterIdValue);
            }
        } else if (filterId.indexOf(sortId) === 0) {
            sortFilter = filterId.replace(sortId, '');

            if (logFilter === true) {
                DataService.filterLog('sortDropDown', sortFilter);
            }
        }
    };

    addPriceRangeFilter(filterId, priceRangeMin, priceRangeMax, logFilter) {
        if (typeof (logFilter) === 'undefined') logFilter = true;
        while (priceFilter.length) {
            priceFilter.shift();
        }

        priceFilter.push(priceRangeMin);
        priceFilter.push(priceRangeMax);
        var filtervalue = priceRangeMin + '-' + priceRangeMax;
        if (logFilter === true) {
            DataService.filterLog(filterId, filtervalue);
        }
    };

    addSubSearchFilter(filterId, subSearch, logFilter) {
        if (typeof (logFilter) === 'undefined') logFilter = true;
        subSearchFilter = subSearch;
        if (logFilter === true) {
            DataService.filterLog(filterId, subSearch);
        }
    };

    addProductQuantityFilter(filterId, productQuantity, logFilter) {
        if (typeof (logFilter) === 'undefined') logFilter = true;
        productQuantityFilter = productQuantity;
        if (logFilter === true) {
            DataService.filterLog(filterId, productQuantity);
        }
    };

    getSelectedFilters(filterId) {
        if (filterId.indexOf(colorId) === 0) {
            return this.getColorFilter();
        } else if (filterId.indexOf(ratingId) === 0) {
            return this.getRatingFilter();
        } else if (filterId.indexOf(prodTimeId) === 0) {
            return this.getProdTimeFilter();
        } else if (filterId.indexOf(imprintLocationCountId) === 0) {
            return this.getImprintLocationCountFilter();
        } else if (filterId.indexOf(imprintColorCountId) === 0) {
            return this.getImprintColorCountFilter();
        } else if (filterId.indexOf(tagId) === 0) {
            return this.getTagFilter();
        } else {
            return [];
        }
    };

    getFilterId(filterId) {
        if (filterId.indexOf(colorId) === 0) {
            return filterId.replace(colorId, '');
        } else if (filterId.indexOf(ratingId) === 0) {
            return filterId.replace(ratingId, '');
        } else if (filterId.indexOf(prodTimeId) === 0) {
            return filterId.replace(prodTimeId, '');
        } else if (filterId.indexOf(imprintLocationCountId) === 0) {
            return filterId.replace(imprintLocationCountId, '');
        } else if (filterId.indexOf(imprintColorCountId) === 0) {
            return filterId.replace(imprintColorCountId, '');
        } else if (filterId.indexOf(tagId) === 0) {
            return filterId.replace(tagId, '');
        } else if (filterId.indexOf(sortId) === 0) {
            return filterId.replace(sortId, '');
        }
    };

    addPageNumber(pageNo) {
        pageNumber = pageNo;
    };

    addPageSize(size) {
        pageSize = size;
    };

    removeFilter(filterId) {
        var index;

        if (filterId.indexOf(colorId) === 0) {
            index = colorFilter.indexOf(filterId.replace(colorId, ''));
            if (index > -1) {
                colorFilter.splice(index, 1);
            }
        } else if (filterId.indexOf(ratingId) === 0) {
            index = ratingFilter.indexOf(filterId.replace(ratingId, ''));
            if (index > -1) {
                ratingFilter.splice(index, 1);
            }
        } else if (filterId.indexOf(prodTimeId) === 0) {
            index = prodTimeFilter.indexOf(filterId.replace(prodTimeId, ''));
            if (index > -1) {
                prodTimeFilter.splice(index, 1);
            }
        } else if (filterId.indexOf(imprintLocationCountId) === 0) {
            index = imprintLocationCountFilter.indexOf(filterId.replace(imprintLocationCountId, ''));
            if (index > -1) {
                imprintLocationCountFilter.splice(index, 1);
            }
        } else if (filterId.indexOf(imprintColorCountId) === 0) {
            index = imprintColorCountFilter.indexOf(filterId.replace(imprintColorCountId, ''));
            if (index > -1) {
                imprintColorCountFilter.splice(index, 1);
            }
        } else if (filterId.indexOf(tagId) === 0) {
            index = tagFilter.indexOf(filterId.replace(tagId, ''));
            if (index > -1) {
                tagFilter.splice(index, 1);
            }
        } else if (filterId.indexOf(sortId) === 0) {
            sortFilter = defaultSort;
        }
    };

    removePriceRangeFilter() {
        while (priceFilter.length) {
            priceFilter.shift();
        }
    };

    removeSubSearchFilter() {
        subSearchFilter = '';
    };

    removeProductQuantityFilter() {
        productQuantityFilter = '';
    };

    clearFilters() {
        pageNumber = 0;
        subSearchFilter = '';
        productQuantityFilter = '';

        while (priceFilter.length) {
            priceFilter.shift();
        }
        while (colorFilter.length) {
            colorFilter.shift();
        }
        while (ratingFilter.length) {
            ratingFilter.shift();
        }
        while (prodTimeFilter.length) {
            prodTimeFilter.shift();
        }
        while (imprintLocationCountFilter.length) {
            imprintLocationCountFilter.shift();
        }
        while (imprintColorCountFilter.length) {
            imprintColorCountFilter.shift();
        }
        while (tagFilter.length) {
            tagFilter.shift();
        }
    };

    getColorElementId(color) {
        return colorId + color;
    };

    getRatingElementId(rating) {
        return ratingId + rating;
    };

    getProductionTimeElementId(time) {
        return prodTimeId + time;
    };

    getImprintLocationCountElementId(imprintLocationCount) {
        return imprintLocationCountId + imprintLocationCount;
    };

    getImprintColorCountElementId(imprintColorCount) {
        return imprintColorCountId + imprintColorCount;
    };

    getTagElementId(tag) {
        return tagId + tag;
    };

    getSortElementId(sort) {
        return sortId + sort;
    };

    getPriceFilter() {
        return priceFilter;
    };

    getColorFilter() {
        return colorFilter;
    };

    getRatingFilter() {
        return ratingFilter;
    };

    getProdTimeFilter() {
        return prodTimeFilter;
    };

    getImprintLocationCountFilter() {
        return imprintLocationCountFilter;
    };

    getImprintColorCountFilter() {
        return imprintColorCountFilter;
    };

    getTagFilter() {
        return tagFilter;
    };

    getSortFilter() {
        return sortFilter;
    };

    getPageNumber() {
        return pageNumber;
    };

    getPageSize() {
        return pageSize;
    };

    getDefaultSort() {
        return defaultSort;
    };

    getDefaultPageSize() {
        return defaultPageSize;
    };

    getSubSearchFilter() {
        return subSearchFilter;
    };

    getProductQuantityFilter() {
        return productQuantityFilter;
    };

    isColorId(filterId) {
        return filterId.indexOf(colorId) === 0;
    };

    isRatingId(filterId) {
        return filterId.indexOf(ratingId) === 0;
    };
}

export default new FilterValues();